/** Home provider tiles — Starcasino artwork only (ListOrder providers) */
export const HOME_PROVIDERS = [
  { title: "Pragmatic Play", slug: "pragmaticplay", logo: "/img/home-providers/pragmaticplay.png" },
  { title: "EGT Digital", slug: "egtdigital", logo: "/img/home-providers/egtdigital.png" },
  { title: "Amusnet", slug: "amusnet", logo: "/img/home-providers/amusnet.png" },
  { title: "Playson", slug: "playson", logo: "/img/home-providers/playson.png" },
  { title: "Evolution", slug: "evolution", logo: "/img/home-providers/evolution.png" },
  { title: "3 Oaks", slug: "3oaksgaming", logo: "/img/home-providers/3oaksgaming.png" },
  { title: "Barbara-bang", slug: "barbarabang", logo: "/img/home-providers/barbarabang.png" },
  { title: "Hacksaw Gaming", slug: "hacksawgaming", logo: "/img/home-providers/hacksawgaming.png" },
  { title: "Play'n GO", slug: "playngo", logo: "/img/home-providers/playngo.png" },
  { title: "Galaxsys", slug: "galaxsys", logo: "/img/home-providers/galaxsys.png" },
  { title: "PG Soft", slug: "pgsoft", logo: "/img/home-providers/pgsoft.png" },
  { title: "NoLimit City", slug: "nolimitcity", logo: "/img/home-providers/nolimitcity.png" },
  { title: "Airdice", slug: "airdice", logo: "/img/home-providers/airdice.png" },
  { title: "Spribe", slug: "spribe", logo: "/img/home-providers/spribe.png" },
  { title: "Wazdan", slug: "wazdan", logo: "/img/home-providers/wazdan.png" },
  { title: "BGaming", slug: "bgaming", logo: "/img/home-providers/bgaming.png" },
  { title: "Big Time Gaming", slug: "bigtimegaming", logo: "/img/home-providers/bigtimegaming.png" },
  { title: "Spinomenal", slug: "spinomenal", logo: "/img/home-providers/spinomenal.png" },
  { title: "Yggdrasil", slug: "yggdrasil", logo: "/img/home-providers/yggdrasil.png" },
  { title: "BetSoft Gaming", slug: "betsoft", logo: "/img/home-providers/betsoft.png" },
  { title: "Iron Dog Studio", slug: "irondog", logo: "/img/home-providers/irondog.png" },
  { title: "NetEnt", slug: "netent", logo: "/img/home-providers/netent.png" },
  { title: "Red Tiger", slug: "redtiger", logo: "/img/home-providers/redtiger.png" },
  { title: "Habanero", slug: "habanero", logo: "/img/home-providers/habanero.png" },
  { title: "TaDa Gaming", slug: "tadagaming", logo: "/img/home-providers/tadagaming.png" },
  { title: "Endorphina", slug: "endorphina", logo: "/img/home-providers/endorphina.png" },
  { title: "Evoplay", slug: "evoplay", logo: "/img/home-providers/evoplay.png" },
  { title: "Spadegaming", slug: "sg", logo: "/img/home-providers/sg.png" },
  { title: "Red Rake Gaming", slug: "redrake", logo: "/img/home-providers/redrake.png" },
  { title: "Ruby Play", slug: "rubyplay", logo: "/img/home-providers/rubyplay.png" },
  { title: "SmartSoft", slug: "smartsoft", logo: "/img/home-providers/smartsoft.png" },
  { title: "Booming Games", slug: "boominggames", logo: "/img/home-providers/boominggames.png" },
  { title: "CT Interactive", slug: "ctinteractive", logo: "/img/home-providers/ctinteractive.png" },
  { title: "Aviatrix", slug: "aviatrix", logo: "/img/home-providers/aviatrix.png" },
];
